module.exports = __webpack_public_path__ + "static/img/Scott_Lycett_desktop.44072fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott_Lycett_desktop.jpg
// module id = N09p
// module chunks = 0